
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/application";
const applicationState = namespace("Application");

import Trail from './Trail.vue';
import FormIcon from './journeyicons/FormIcon.vue';
import GavelIcon from './journeyicons/GavelIcon.vue';
import ClockEndCircle from './journeyicons/ClockEndCircle.vue';

import InstructionWindowFooter from '../components/InstructionWindowFooter.vue';
import PathSidebar from '../components/PathSidebar.vue';
import ApplicationForReviewAppLeaveRefusedPg from '../components/AppLeaveRefused/ApplicationForReviewAppLeaveRefusedPg.vue';
import TheHearingAppLeaveRefusedPg from '../components/AppLeaveRefused/TheHearingAppLeaveRefusedPg.vue';
import FinalDecisionOnLeaveToAppealAppLeaveRefusedPg from '../components/AppLeaveRefused/FinalDecisionOnLeaveToAppealAppLeaveRefusedPg.vue';

import {activatePage, evaluateCompletedTrails, evaluatePageState} from '@/components/utils/TrailOperations';
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages";

@Component({
    components:{
        Trail,
        FormIcon,
        GavelIcon,
        ClockEndCircle,
        InstructionWindowFooter,
        PathSidebar,
        ApplicationForReviewAppLeaveRefusedPg,
        TheHearingAppLeaveRefusedPg,
        FinalDecisionOnLeaveToAppealAppLeaveRefusedPg
    }
})
export default class AppellantLeaveRefusedJourneyMap extends Vue {
    
    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    dataReady = false;
    completedTrail :boolean[] = []
    numOfPages = 0;
    currentStep = 0;
    pageState : {active:boolean; status:string; ready:boolean;}[] = [];

    showWindow = false;
    windowTitle = '';
    pathTypes = [] as string[];
    pathHeights = [] as string[];

    applicationForReviewContent = false;
    theHearingContent = false;   
    finalDecisionOnLeaveToAppealContent = false; 

    mounted(){
        this.dataReady = false;

        this.currentStep = this.stPgNo.APP_LEAVE_REFUSED._StepNo;
        this.numOfPages = Object.keys(this.stPgNo.APP_LEAVE_REFUSED).length-1;

        this.getJourneyMapCurrentState();
        
        this.dataReady = true;
    }

    public completed(order, checked){        
        activatePage(order, checked, this.currentStep)
        this.getJourneyMapCurrentState();
    }

    public getJourneyMapCurrentState(){
        this.completedTrail = evaluateCompletedTrails(this.numOfPages, this.currentStep);
        this.pageState = evaluatePageState(this.numOfPages, this.currentStep);
    }

    public displayWindow(contentType: string){
        
        this.applicationForReviewContent = false;
        this.theHearingContent = false;   
        this.finalDecisionOnLeaveToAppealContent = false; 

        if (contentType == "Application for Review"){

            this.windowTitle = "Application for Review";
            this.pathTypes = ["share"];
            this.pathHeights = ['40rem'];
            this.applicationForReviewContent = true;

        } else if (contentType == "The Hearing"){
            
            this.windowTitle = "The Hearing";
            this.pathTypes = ["gavel"];
            this.pathHeights = ['6rem'];
            this.theHearingContent = true;

        } else if (contentType == "Final Decision on Leave to Appeal"){
            
            this.windowTitle = "Final Decision on Leave to Appeal";
            this.pathTypes = ["info"];
            this.pathHeights = ['3rem'];
            this.finalDecisionOnLeaveToAppealContent = true;
        } 
        this.showWindow = true;
    }

}
